import axios from "axios";

const config = {
    headers: {
        "Content-Type": "application/json",
        "x-api-key": undefined
    }
};

export const _fasteningType_Z1 = [
    "--None--",
    "3-point",
    "adapter",
    "eHZ",
    "eHZ with free TE",
    "eHZ without free TE",
    "Adapter with free TE",
    "Adapter without free TE"
];

export const _fasteningType_Z2 = [
    "--None--",
    "3-point",
    "3-point - bridge",
    "3-point - cover",
    "3-point - dummy-meter",
    "3-point - loop",
    "3-point - terminal block",
    "adapter",
    "eHZ"
];

export const _commentTypes_flatX = [
    "--None--",
    "Bild ohne Abdeckung, keine freien TE vorhanden",
    "Keine TE sichtbar wegen Abdeckung",
    "#LoopNICHTbeschriftet",
    "Fehlender Stromlaufplan",
    "Freier Zählerplatz auf Bild nicht erkennbar",
    "Kabel beschriftet",
    "Kabel nur mit Richtung beschriftet",
    "Kabel nur nummeriert",
    "Kein Nullleiter unter der Verdrahtung erkennbar",
    "Keine Verdrahtung des Zählerplatzes",
    "Mehrere freie Zählerplätze",
    "Netzzähler ist nicht zu sehen",
    "sonnenProtect 8000 als AC-Insel",
    "Stromlaufplan entspricht nicht dem sonnenMesskonzept",
    "getrennter Zählerschrank"
];
export const _commentTypes_direct = [
    "--None--",
    "Bild ohne Abdeckung, keine freien TE vorhanden",
    "Keine TE sichtbar wegen Abdeckung",
    "Keine Hutschienensteckdose/keine Steckdose am Zählerschrank",
    "mehrere Zähler erkennbar (Flat direkt)",
    "Netzzähler auf Bild nicht erkennbar (Flat direkt)",
    "Mobilfunkprüfung negativ und LAN-Anbindung nicht erkennbar ",
    "Keine Mobilfunkprüfung eingereicht"
];
export const _lanConnections = ["None", "Ethernet", "PLC", "LAN in clearing"];
export const _lteConnections = ["None", "Not possible", "Possible", "Probable"];

export async function changeTaskState(jira_task, new_status, username, appConfig) {
    const api_jira = `${appConfig.JIRA_SERVER_URI}/v1/tasks/${jira_task}/status/?new_status=${new_status}`;
    config.headers["x-api-key"] = appConfig.JIRA_SERVER_TOKEN;
    const data = {
        by: username
    };

    await axios({ method: "put", url: api_jira, data: data, headers: config.headers })
        .then((response) => {
            console.log(`Task ${jira_task} - change state: ${new_status}`, response);
        })
        .catch((err) => {
            console.log("Task - change state: error", err);
        });
}
export async function changeTaskDueDate(jira_task, due_date, appConfig) {
    const api_jira = `${appConfig.JIRA_SERVER_URI}/v1/tasks/update_field/${jira_task}/?field=duedate&value=${due_date}`;
    config.headers["x-api-key"] = appConfig.JIRA_SERVER_TOKEN;
    let data = {};

    await axios({ method: "put", url: api_jira, data: data, headers: config.headers })
        .then((response) => {
            console.log(`Task ${jira_task} - change duedata to ${due_date}`, response);
        })
        .catch((err) => {
            console.log("Task - change duedata: error", err);
        });
}

export async function changeTaskOperator(jira_task, operator, username, appConfig) {
    const api_jira = `${appConfig.JIRA_SERVER_URI}/v1/tasks/${jira_task}/operator?operator=${operator}`;
    config.headers["x-api-key"] = appConfig.JIRA_SERVER_TOKEN;
    const data = {
        by: username
    };

    await axios({ method: "put", url: api_jira, data: data, headers: config.headers })
        .then((response) => {
            console.log("Task - change state", response);
        })
        .catch((err) => {
            console.log("Task - change state: error", err);
        });
}

export async function updateSalesforceObject(sf_mi, salesforceData, appConfig, callbackFn) {
    const api_sf = `${appConfig.SF_SERVER_URI}/bp/metering/meter_cabinet_check/webapp/${sf_mi}`;
    const config = {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": appConfig.SF_SERVER_TOKEN
        }
    };
    await axios({ method: "post", url: api_sf, data: salesforceData, headers: config.headers })
        .then((response) => {
            console.log("POST response", response);
            return callbackFn(false);
        })
        .catch((err) => {
            console.log("POST error", err);
            return callbackFn(true);
        });
}
